
export default [
  {
    path: '/erro',
    name: 'erro',
    component: () => import('../components/app/erro/Erro.vue')
    /* SEO (title, description, robots=noindex, canonical) é gerenciado
       dinamicamente pelo composable useSeo() dentro do componente. */
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../components/app/links/LinkBio.vue')
    /* SEO (title, description, JSON-LD, canonical, hreflang) é gerenciado
       dinamicamente pelo composable useSeo() dentro do componente. */
  },
  {
    path: '/pago',
    name: 'pagamento',
    component: () => import('../components/app/pagamento/PagamentoLink.vue')
    /* Sem useSeo. Bloqueio em robots.txt (Disallow: /pago). */
  },
  {
    path: '/contenido',
    name: 'conteudo-video',
    component: () => import('../components/app/conteudo/ConteudoVideo.vue')
    /* SEO indexável: title, description, JSON-LD VideoObject, canonical,
       hreflang — useSeo() no componente. */
  },
  {
    path: '/testimonios',
    name: 'testimonios',
    component: () => import('../components/app/depoimentos/Depoimentos.vue')
    /* SEO (title, description, JSON-LD com Reviews, canonical e hreflang)
       é gerenciado dinamicamente pelo composable useSeo() dentro do
       componente. Página indexável (prova social rica). */
  },
  {
    /* Compatibilidade: links antigos compartilhados apontavam para
       /depoimentos (em português). Redireciona para a URL em espanhol. */
    path: '/depoimentos',
    redirect: '/testimonios'
  },
  {
    path: '/profesionales',
    name: 'profesionales',
    component: () => import('../components/app/clientes/ClientesPage.vue')
    /* Sem useSeo. Bloqueio em robots.txt (Disallow: /profesionales). */
  },
  {
    /* Compatibilidade: links antigos compartilhados pelo WhatsApp
       apontavam para /clientes. Redireciona para a URL em espanhol. */
    path: '/clientes',
    redirect: '/profesionales'
  },
  {
    path: '/oligoscan',
    name: 'oligoscan',
    component: () => import('../components/app/oligoscan/OligoscanLanding.vue'),
    meta: {
      title: 'OligoScan ahora es OligoCheck | Análisis Mineral Intracelular'
    }
  },
  {
    /* Landing focada em capturar buscas por "oligocheck" (compra +
       suporte) — conteúdo 100% sobre o produto atual, sem referência
       ao rebranding. SEO (title, description, JSON-LD Product com
       aggregateRating, FAQPage, canonical e hreflang) é gerenciado
       pelo composable useSeo() dentro do componente. */
    path: '/oligocheck',
    name: 'oligocheck',
    component: () => import('../components/app/oligocheck/OligocheckLanding.vue')
  },
  {
    /* Versão Brasil da landing /oligocheck — idioma travado em Português
       (sem LangSwitcher) e selo regulatório da ANVISA. Reaproveita a
       OligocheckLanding via props (pais="brasil"). SEO/canonical/hreflang
       próprios geridos pelo useSeo() do componente. */
    path: '/oligocheck/brasil',
    name: 'oligocheck-brasil',
    component: () => import('../components/app/oligocheck/OligocheckBrasil.vue')
  },
  {
    /* Versão Colômbia da landing /oligocheck — idioma travado em Espanhol
       (sem LangSwitcher) e selo regulatório do INVIMA. Reaproveita a
       OligocheckLanding via props (pais="colombia"). */
    path: '/oligocheck/colombia',
    name: 'oligocheck-colombia',
    component: () => import('../components/app/oligocheck/OligocheckColombia.vue')
  },
  {
    /* Obrigado /oligocheck — sem useSeo. Disallow em robots.txt */
    path: '/oligocheck/gracias',
    name: 'oligocheck-gracias',
    component: () => import('../components/app/oligocheck/OligocheckGracias.vue')
  },
  {
    path: '/oligoscan/gracias',
    name: 'oligoscan-gracias',
    component: () => import('../components/app/oligoscan/OligoscanObrigado.vue'),
    meta: { title: '¡Gracias! | OligoCheck' }
  },
  {
    /* Landing institucional para captura de profesionales sanitarios
       en Madrid — demostración privada en consulta. Apenas ES, no
       indexable (bloqueada em robots.txt). Reaproveita a página de
       obrigado /oligocheck/gracias após envio do FormularioLead. */
    path: '/madri-local',
    name: 'madri-local',
    component: () => import('../components/app/madri-local/MadriLocalLanding.vue'),
    meta: { title: 'OligoCheck en Madrid · Demostración privada en su consulta' }
  },
  {
    /* Versão 2 da landing /madri-local — orientada a TRÁFEGO FRÍO.
       Reutiliza a estrutura da OligoscanLanding (alerta topo + hero
       com 2 caminhos + seção explicativa + features + tech-box de
       espectrofotometría + FAQ + formulário), sem o ângulo de
       rebranding e com escassez institucional reforçada (bloco de
       agenda). Bloqueada em robots.txt e sem useSeo. */
    path: '/madri-local-v2',
    name: 'madri-local-v2',
    component: () => import('../components/app/madri-local/MadriLocalLandingV2.vue'),
    meta: { title: 'OligoCheck en Madrid · Presentación exclusiva para profesionales' }
  },
  {
    /* Página de obrigado dedicada da campanha Madrid (v1 e v2).
       Recebe o lead após envio do FormularioLead (AC form 43) com
       countdown + redirect automático para WhatsApp comercial.
       Sem useSeo, Disallow em robots.txt. */
    path: '/madri-local/gracias',
    name: 'madri-local-gracias',
    component: () => import('../components/app/madri-local/MadriLocalGracias.vue'),
    meta: { title: '¡Gracias! · Demostración en Madrid | OligoCheck' }
  },
  {
    /* Landing do evento "Malta Health Innovation Circle" (SO/check).
       Vídeo no topo + seções (sobre, sessões, perfil) e CTA direto para
       WhatsApp. Conteúdo em inglês, sem LangSwitcher e sem useSeo. */
    path: '/malta',
    name: 'malta-health',
    component: () => import('../components/app/malta-health/MaltaHealthLanding.vue'),
    meta: { title: 'Malta Health Innovation Circle' }
  },
  {
    /* Página de obrigado do evento Malta — recebe o lead do FormularioLead
       e redireciona para o WhatsApp comercial. Sem useSeo / noindex. */
    path: '/malta/gracias',
    name: 'malta-gracias',
    component: () => import('../components/app/malta-health/MaltaHealthGracias.vue'),
    meta: { title: 'Thank You · Malta Health Innovation Circle' }
  },
  {
    /* Versão 2 da landing /malta — clone da MaltaHealthLanding para
       iterar novas variações do evento sem afetar a v1. Mesmo conteúdo
       em inglês, sem LangSwitcher e sem useSeo. */
    path: '/malta-v2',
    name: 'malta-health-v2',
    component: () => import('../components/app/malta-health/MaltaHealthLandingV2.vue'),
    meta: { title: 'Malta Health Innovation Circle' }
  },
  {
    /* Página de obrigado da v2 do evento Malta — recebe o lead do
       FormularioLead e redireciona para o WhatsApp comercial. */
    path: '/malta-v2/gracias',
    name: 'malta-v2-gracias',
    component: () => import('../components/app/malta-health/MaltaHealthGraciasV2.vue'),
    meta: { title: 'Thank You · Malta Health Innovation Circle' }
  },
  {
    /* Versão 3 da landing /malta — clone da MaltaHealthLandingV2 para
       iterar novas variações do evento sem afetar a v1/v2. Mesmo conteúdo
       em inglês, sem LangSwitcher e sem useSeo. */
    path: '/malta-v3',
    name: 'malta-health-v3',
    component: () => import('../components/app/malta-health/MaltaHealthLandingV3.vue'),
    meta: { title: 'Malta Health Innovation Circle' }
  },
  {
    /* Página de obrigado da v3 do evento Malta — recebe o lead do
       FormularioLead e redireciona para o WhatsApp comercial. */
    path: '/malta-v3/gracias',
    name: 'malta-v3-gracias',
    component: () => import('../components/app/malta-health/MaltaHealthGraciasV3.vue'),
    meta: { title: 'Thank You · Malta Health Innovation Circle' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/erro"
  },
]
